import {UserContext} from 'lib/userContext';
import {useContext} from 'react';

export const useAccessLevel = () => {
  const {accessLevel} = useContext(UserContext);
  return {
    accessLevel,
    isAdmin: accessLevel === 'admin_access',
    isMaster: ['admin_access', 'master_account_access'].includes(accessLevel),
    isMasterOnly: accessLevel === 'master_account_access'
  };
};
